<template>
    <div>
        <config-main-title>
            Modelos de Documento
        </config-main-title>

        <div class="row mb-2">
            <div class="col col-12 col-md-6" v-if="$store.state.user.medico">
                <div class="input-group mb-1">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">
                            <i class="fas fa-user-md fa-fw"></i>
                        </span>
                    </div>
                    <label class="form form-control" disabled>{{ $store.state.user.medico.search }}</label>
                </div>
            </div>
            <div class="col col-12 col-md-6" v-else>
                <az-input
                    placeholder="Todos"
                    icon="fas fa-user-md fa-fw"
                    type="select"
                    optionsMode="aql"
                    service="medicos.index"
                    optionsName="medicos-cadastro"
                    :optionsParm="{ ativos: true }"
                    v-model="medico"
                    @change.native="selecionarMedico()" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <div class="btn-group mb-1" role="group" aria-label="Basic example">
                    <button type="button" class="btn" :class="viewMode == 'A' ? 'btn-secondary' : 'btn-outline-secondary'"
                    @click="viewMode = 'A'">
                        Ativos
                    </button>
                    <button type="button" class="btn" :class="viewMode == 'T' ? 'btn-secondary' : 'btn-outline-secondary'"
                    @click="viewMode = 'T'">
                        Todos
                    </button>
                </div>
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-success" @click="incluir ()">
                    Incluir Modelo
                </button>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col col-12">
                <az-input 
                    ref="pesquisa"
                    placeholder="Pesquisar..."
                    icon="fas fa-search fa-fw"
                    v-model="search">
                    <template v-slot:buttonposb>
                        <div class="input-group-append" v-if="!medico">
                            <button type="button" class="btn btn-outline-primary" title="Incluir Profissionais" @click="incluir_medico_bloco()">
                                <i class="fa-solid fa-user-plus"></i>
                            </button>
                            <button type="button" class="btn btn-outline-danger" title="Incluir Profissionais" @click="remover_medico_bloco()">
                                <i class="fa-solid fa-user-minus"></i>
                            </button>
                        </div>

                        <div class="input-group-append" v-else>
                            <button type="button" class="btn btn-outline-primary" title="Incluir Profissionais" @click="editar_lista_docs()">
                                <i class="fa-solid fa-list-check"></i>
                            </button>
                        </div>
                    </template>
                </az-input>
            </div>
        </div>

        <template v-if="!lista || !lista.length">
            <az-empty-state msg="Nenhum documento criado." />
        </template>

        <template v-else>
            
            <div class="alert alert-warning" v-if="anexos_vencidos && anexos_vencidos.length">
                <a href="#" @click.prevent="ver_vencidos = !ver_vencidos" class="alert-link">
                    {{ anexos_vencidos.length }} arquivo(s) vencido(s)
                </a>
            </div>

            <ul class="list-group">
                <li class="list-group-item d-flex justify-content-between hover-bg" v-for="(doc, idoc) in lista" :key="idoc">
                    <div>
                        <a href="#" @click.prevent="editar(doc)" class="card-link">
                            {{ doc.st_nome }}
                        </a>
                        <span class="badge badge-secondary">#{{ doc.id_modelo_documento }}</span>
                        <span v-if="doc.id_medico" class="ml-3" title="Documento específico do profissional">
                            <i class="fas fa-user-md"></i>
                        </span>
                    </div>
                    <div class="custom-control custom-switch ml-3" v-if="viewMode == 'T'">
                        <input type="checkbox" class="custom-control-input"
                            :id="'ativo-' + idoc"  v-model="doc.fl_ativo" @change="toggle(doc)">
                        <label class="custom-control-label" :for="'ativo-' + idoc"></label>
                    </div>
                    <div class="d-flex" v-else>
                        <div v-if="doc.js_classes" class="mr-3">
                            <a href="#" @click.prevent="search == '&quot;' + tag + '&quot;' ? search = '' : search = '&quot;' + tag + '&quot;'"
                                v-for="(tag, itx) in doc.js_classes" :key="itx">
                                <span class="badge badge-success ml-1">
                                    {{ tag }}
                                </span>
                            </a>
                        </div>
                        
                        <div v-if="doc.fl_para_recepcao">
                            <span data-toggle="tooltip" data-placement="top" title="Disponível para Recepção">
                                <i class="fas fa-user-friends mr-3"></i>
                            </span>
                        </div>
                        <div>
                            <span class="badge badge-secondary mr-3" data-toggle="tooltip" data-placement="top" title="Profissionais Selecionados"
                                v-if="!dados.id_medico && doc.medico_lista.length">
                                {{ doc.medico_lista.length }}
                            </span>
                        </div>
                        <span class="text-warning mr-3" data-toggle="tooltip" data-placement="top" title="Nenhum profissional selecionado."
                            v-if="!doc.id_medico && !doc.medico_lista.length && !doc.fl_para_recepcao">
                            <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        </span>
                        <button type="button" class="btn btn-outline-primary btn-sm mr-2"
                            data-toggle="tooltip" data-placement="top" title="Profissionais Habilitados"
                            v-if="!doc.id_medico" @click="medico_lista(doc)">
                            <i class="fas fa-user-md"></i>
                        </button>
                        <button type="button" class="btn btn-secondary btn-sm mr-2"
                            data-toggle="tooltip" data-placement="top" title="Documento específico do profissional"
                            v-else>
                            <i class="fas fa-user-md"></i>
                        </button>

                        <button type="button" class="btn btn-sm btn-outline-primary mr-2" title="Anexos" v-if="!doc.fl_layout_word && doc.arquivos && doc.arquivos.length" @click="enviar_arquivo(doc)">
                            <i class="fa-solid fa-paperclip"></i>
                            <span class="badge badge-primary ml-1" v-if="doc.arquivos && doc.arquivos.length">
                                {{ doc.arquivos.length }}
                            </span>
                        </button>

                        <button type="button" class="btn btn-outline-danger btn-sm mr-2"
                            data-toggle="tooltip" data-placement="top" title="Remover Modelo"
                            @click="remover(doc)" v-if="1==0">
                            <i class="far fa-trash-alt"></i>
                        </button>
                    </div>
                </li>
            </ul>

        </template>

        <!-- Modal -->
        <div class="modal fade" id="editarDocModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Modelo de Documento {{ item.id_modelo_documento ? '' : '(Novo)' }}
                            <span class="badge badge-secondary ml-2" v-if="item.id_modelo_documento">
                                #{{ item.id_modelo_documento }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Nome"
                                    sizing="sm"
                                    required
                                    :validate="validate"
                                    v-model="item.st_nome" />
                            </div>
                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="Título"
                                    sizing="sm"
                                    required
                                    :validate="validate"
                                    v-model="item.st_titulo" />
                            </div>
                        </div>

                        <div class="form-row mt-1">
                            <div class="col col-12" :class="( item.fl_para_recepcao && item.fl_html ) ? 'col-md-2' : 'col-md-4'">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Texto Rico"
                                    :edicao="!item.fl_layout_word"
                                    :validate="validate"
                                    v-model="item.fl_html" />
                            </div>
                            <div class="col col-12 col-md-2" v-if="item.fl_para_recepcao && item.fl_html">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Edição HTML"
                                    :validate="validate"
                                    v-model="item.fl_edicao_raw_html" />
                            </div>
                            
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Herdar Anterior no Lançamento"
                                    :validate="validate"
                                    v-model="item.fl_herdar_anterior" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Disponível para Recepção"
                                    :validate="validate"
                                    v-model="item.fl_para_recepcao" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Layout de Impressão em Arquivo Word"
                                    :edicao="!item.fl_html"
                                    :validate="validate"
                                    v-model="item.fl_layout_word" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Não imprimir título"
                                    v-if="!item.fl_layout_word"
                                    :validate="validate"
                                    v-model="item.fl_imprimir_sem_titulo" />
                            </div>
                            <div class="col col-12 col-md-4" v-if="item.fl_para_recepcao">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Salvar na Recepção"
                                    :validate="validate"
                                    v-model="item.fl_salvar_recepcao" />
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col col-12 col-md-4" v-if="ipsign">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Assinar documento com o IPSign"
                                    vif="!item.fl_layout_word"
                                    :validate="validate"
                                    v-model="item.fl_ipsign" />
                            </div>
                            <div class="col col-12 col-md-4" v-else-if="zerodox">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Assinar documento com o ZeroDox"
                                    v-if="!item.fl_layout_word"
                                    :validate="validate"
                                    v-model="item.fl_zerodox" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Ocultar informação do médico no rodapé"
                                    :validate="validate"
                                    v-if="!item.fl_layout_word"
                                    v-model="item.fl_ocultar_medico_rodape" />
                            </div>
                            <div class="col col-12 col-md-4">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Não permitir edição"
                                    :validate="validate"
                                    v-model="item.fl_block_edit" />
                            </div>
                        </div>

                        <div class="form-row" v-if="!item.fl_layout_word">
                            <div class="col col-12 col-md-4">
                                <div class="input-group input-group-sm">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">
                                            <small>Papel</small>
                                        </span>
                                    </div>
                                    <select class="form-control" type="select" v-model="item.st_papel">
                                        <option value="">Selecionado</option>
                                        <option value="A4">A4</option>
                                        <option value="A4-T">A4 (Timbrado)</option>
                                        <option value="A4-NT">A4 (Não Timbrado)</option>
                                        <option value="A5">A5</option>
                                        <option value="A5-T">A5 (Timbrado)</option>
                                        <option value="A5-NT">A5 (Não Timbrado)</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col col-12 col-md-4">
                                <div class="input-group input-group-sm">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text" id="basic-addon1">
                                            <small>Tamanho</small>
                                        </span>
                                    </div>
                                    <select class="form-control" type="select" v-model="item.st_tamanho_fonte">
                                        <option value="">Padrão</option>
                                        <option value="14">14</option>
                                        <option value="13">13</option>
                                        <option value="12">12</option>
                                        <option value="11">11</option>
                                        <option value="10">10</option>
                                        <option value="9">9 (Padrão)</option>
                                        <option value="8">8</option>
                                        <option value="7">7</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col col-12 col-md-4" v-if="item.fl_para_recepcao && item.fl_recepcao_final && item.st_descricao && item.st_descricao.indexOf('[') >= 0">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Quebrar Proceds. por Guia"
                                    :validate="validate"
                                    v-model="item.fl_quebrar_por_guia" />
                            </div>
                            <div class="col col-12 col-md-4" v-if="(ipsign || zerodox) && (item.fl_ipsign || item.fl_zerodox) && !item.fl_para_recepcao">
                                <az-input
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Anexar documento como laudo"
                                    v-if="!item.fl_layout_word"
                                    :validate="validate"
                                    v-model="item.fl_ipsign_laudo" />
                            </div>
                        </div>

                        <div class="mt-3" v-if="item.fl_layout_word">

                            <div v-if="item.id_modelo_documento">

                                <template v-if="item.in_qockpit_doc_id">
                                    <az-input 
                                        type="label"
                                        :label="'Documento QOCKPIT: #' + item.in_qockpit_doc_id">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-primary" type="button" @click="visualizar_qockpit_doc(item.in_qockpit_doc_id)" title="Visualizar">
                                                    <i class="fas fa-eye" aria-hidden="true"></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </template>

                                <template v-else>

                                    <ul class="list-group mb-2" v-if="item.arquivos">
                                        <li class="list-group-item" v-for="(arq, iax) in item.arquivos" :key="iax">
                                            {{ arq.arquivo.st_titulo }}
                                        </li>
                                    </ul>

                                    <button class="btn btn-primary mr-1" type="button" @click="enviar_arquivo_doc()">
                                        <i class="fas fa-plus mr-2"></i>
                                        Arquivo
                                    </button>

                                </template>

                                <button class="btn btn-outline-dark mr-1" type="button" @click="get_qockpit_list()" v-if="qockpit" :disabled="!!item.arquivos.length || $store.state.loading">
                                    <i class="fa fa-search mr-2" aria-hidden="true"></i>
                                    QOCKPIT
                                </button>

                                <az-file-upload
                                    :blockcelular="true"
                                    :tem_validade="true"
                                    extensions="docx"
                                    ref="upload_doc"
                                    @refresh="refresh_arquivos"
                                    :arquivos="item.arquivos"
                                    :parms="{ model_type: 'modeloDocumento', model_id: item.id_modelo_documento }" />

                            </div>

                            <div class="alert alert-info" v-else> 
                                Necessário salvar o modelo para poder enviar o arquivo.
                            </div>

                        </div>

                        <template v-if="item.fl_layout_word && item.in_qockpit_doc_id">
                            <!-- Documento QOCKPIT -->
                        </template>

                        <template v-else>

                            <template v-if="item.fl_html && ( !item.fl_para_recepcao || !item.fl_edicao_raw_html )">
                                <div class="mt-2">
                                    <az-editor ref="htmleditor" v-model="item.st_descricao" editorStyle="height: 320px" />
                                </div>
                            </template>

                            <template v-else>
                                <az-input
                                    class="mt-2"
                                    label="Conteúdo"
                                    type="textarea"
                                    rows="8"
                                    required
                                    :validate="!item.fl_layout_word ? validate : false"
                                    v-model="item.st_descricao" />
                            </template>

                            <template v-if="campos && campos.length">
                                <az-input
                                    sizing="sm"
                                    icon="fa fa-plus"
                                    type="select"
                                    optionsMode="json"
                                    :optionsList="campos"
                                    optionsDisplay="search"
                                    v-model="novoCampo"
                                    @input="incluir_novo_campo()" />
                            </template>

                        </template>

                        <az-sub-title class="mt-1" title="Classificação" />
                        <div class="mb-3">
                            <multiselect
                                v-model="item.js_classes"
                                :options="options_classes"
                                :multiple="true"
                                :taggable="true"
                                @tag="addTag"
                                placeholder="Selecione uma classificação..."
                                selectLabel="Pressione [ENTER] para selecionar"
                                deselectLabel="Pressione [ENTER] para remover"
                                tagPlaceholder="Pressione [ENTER] para incluir"
                                selectedLabel="Selecionado">
                                <template slot="noOptions">
                                    Nenhuma classificação criada.
                                </template>
                            </multiselect>
                        </div>

                        <template v-if="item.fl_para_recepcao">
                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        label="Exibir na tela final da recepção (guia/recibo)"
                                        type="checkbox-group"
                                        v-model="item.fl_recepcao_final" />
                                </div>
                            </div>
                        </template>

                        <template v-if="item.fl_para_recepcao && ( item.fl_recepcao_final || item.procedimento_lista && item.procedimento_lista.length )">
                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        label="Servidor de Impressão"
                                        placeholder="Não definido..."
                                        v-model="item.st_serv_imp" />
                                </div>
                            </div>
                        </template>

                        <template v-if="item.fl_layout_word && item.fl_ipsign">
                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        label="Perguntas para preenchimento pelo assinante (IPSign)"
                                        placeholder="Nenhuma..."
                                        type="select"
                                        optionsMode="aql"
                                        :optionsParm="{ ativos: 1 }"
                                        optionsData="id_modelo_prontuario"
                                        optionsName="modelo-pront-pergunta-no-modelo-doc"
                                        service="modelos.index"
                                        v-model="item.id_modelo_prontuario">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append" v-if="item.id_modelo_prontuario">
                                                <span class="input-group-text">#{{ item.id_modelo_prontuario }}</span>
                                            </div>
                                        </template>
                                    </az-input> 
                                </div>
                            </div>
                        </template>

                        <template v-if="!item.fl_layout_word">

                            <div class="row">
                                <div class="col col-12">
                                    <az-input
                                        label="Modelo de Cabeçalho"
                                        type="select"
                                        placeholder="Padrão do Procedimento..."
                                        optionsMode="aql"
                                        service="cabecalhos.index"
                                        :optionsParm="{ ativos: true }"
                                        optionsData="id_cabecalho_laudo"
                                        v-model="item.id_cabecalho_laudo" />
                                </div>
                            </div>

                        </template>

                        <template v-if="item.fl_ipsign">

                            <az-sub-title class="mt-3" title="IPSign" />

                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Chave da assinatura Ipsign"
                                        placeholder="Chave da assinatura Ipsign..."
                                        v-model="item.st_chave_assinatura_ipsign" />
                                </div>

                                <div class="col col-12 col-md-3">
                                    <az-input
                                        label="Alinhamento Vertical"
                                        placeholder="Padrão..."
                                        type="select"
                                        :optionsList="[
                                            { id: '0', search: 'Abaixo' },
                                            { id: '1', search: 'Centralizado' },
                                            { id: '2', search: 'Acima' },
                                        ]"
                                        optionsData="id"
                                        v-model="item.in_ipsign_ass_v" />
                                </div>

                                <div class="col col-12 col-md-3">
                                    <az-input
                                        label="Alinhamento Horizontal"
                                        placeholder="Padrão..."
                                        type="select"
                                        :optionsList="[
                                            { id: '0', search: 'Abaixo' },
                                            { id: '1', search: 'Centralizado' },
                                            { id: '2', search: 'Acima' },
                                        ]"
                                        optionsData="id"
                                        v-model="item.in_ipsign_ass_h" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col col-12 col-md-6">
                                    <az-input
                                        label="Anexar PDF Retornado no Tipo de Arquivo"
                                        type="select"
                                        placeholder="Qualquer Arquivo..."
                                        :validate="validate"
                                        service="tipo_arquivos.index"
                                        optionsData="id_tipo_arquivo"
                                        optionsMode="aql"
                                        v-model="item.id_tipo_arquivo" />
                                </div>
                            </div>

                            <div class="form-row mt-3">
                                <div class="col col-12">
                                    <az-input  
                                        sizing="sm"
                                        type="checkbox-group"
                                        label="Enviar documento para assinatura na confirmação da marcação"
                                        v-model="item.fl_enviar_confirm" />
                                </div>
                            </div>

                        </template>

                        <template v-if="!item.fl_layout_word">

                            <template v-if="item.arquivos.length">
                                <az-sub-title class="mt-3" title="Arquivos" />
                                <ul class="list-group mt-3" v-if="item.arquivos.length">
                                    <li class="list-group-item d-flex justify-content-between" v-for="(arq, iax) in item.arquivos" :key="iax">
                                        <a :href="arq.arquivo.temporary_url" class="card-link" target="_blank">
                                            <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
                                            {{ arq.arquivo.st_titulo }}
                                        </a>
                                        <a href="#" @click.prevent="remover_anexo(arq, iax)" class="card-link text-danger">
                                            <i class="fa fa-trash-o" aria-hidden="true"></i>
                                        </a>
                                    </li>
                                </ul>
                            </template>

                        </template>

                        <div class="mt-3" v-if="item.fl_zerodox">
                            <az-sub-title class="mt-3" title="Zerodox" />
                            <div class="row">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        label="Tipo de documento ID no Zerodox"
                                        v-model="item.st_tipo_documento" />
                                </div>
                            </div>
                        </div>

                        <!-- Solicitar Procedimento -->
                        <az-sub-title class="mt-3" title="Solicitar Procedimento" />
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input  
                                    sizing="sm"
                                    type="checkbox-group"
                                    label="Solicitar Procedimento ao Lançar o Documento"
                                    v-model="item.fl_solic_proc" />
                            </div>
                        </div>

                        <div class="form-row" v-if="item.fl_solic_proc">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    label="Procedimento"
                                    placeholder="Procedimento..."
                                    type="autocomplete"
                                    optionsMode="aql"
                                    optionsName="procedimentos.modelo"
                                    service="procedimentos.index"
                                    :optionsParm="{
                                        pep: true,
                                        cbhpm: true,
                                    }"
                                    required
                                    :validate="validate"
                                    v-model="item.procedimento_solic" />
                            </div>

                            <div class="col col-12 col-md-6">
                                <az-input
                                    label="CID"
                                    placeholder="CID..."
                                    sizing="sm"
                                    type="autocomplete"
                                    optionsMode="aql"
                                    service="cids.index"
                                    optionsDisplay="search"
                                    v-model="item.cid_solic"
                                    :validate="validate">
                                </az-input>
                            </div>
                        </div>

                        <!-- Filtros -->
                        <template v-if="item.fl_para_recepcao">
                            <filtro-model
                                class="my-3"
                                v-model="item.filtros"
                                :validate="validate"
                                :opcoes="lista_opcoes_filtro" />

                            <div class="row mt-3">
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        type="number"
                                        label="Idade Mínima"
                                        placeholder="0"
                                        v-model="item.in_paciente_idade_minima" />
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        type="number"
                                        label="Idade Máxima"
                                        placeholder="999"
                                        v-model="item.in_paciente_idade_maxima" />
                                </div>
                                <div class="col col-12 col-md-4">
                                    <az-input
                                        type="sexo"
                                        placeholder="Qualquer"
                                        label="Sexo do Paciente"
                                        v-model="item.ch_paciente_sexo" />
                                </div>
                            </div>

                            <br>

                            <filtro-regra-campos 
                                v-model="item.js_regras_pre_atend" 
                                :block_grupo="true"
                                :validate="validate"
                                title="Filtros por Formulário de Pré-Atendimento"></filtro-regra-campos>

                            <br><br><br>
                        </template>

                        <!-- Assinaturas -->
                        <template v-if="item.fl_ipsign">
                            <az-sub-title class="mt-3" title="Múltiplas Assinaturas IPSIGN" />

                            <!-- Lista de Assinaturas Inline -->
                            <div v-if="item.assinaturas && item.assinaturas.filter(a => !a.remover).length" class="mb-3">
                                <div v-for="(assinatura, index) in item.assinaturas.filter(a => !a.remover)" 
                                     :key="index" 
                                     class="border rounded p-2 mb-2">
                                    <div class="form-row align-items-end">
                                        <!-- Tipo -->
                                        <div class="col-auto">
                                            <az-input
                                                label="Tipo"
                                                type="select"
                                                sizing="sm"
                                                :optionsList="[
                                                    { id: 'M', search: 'Médico' },
                                                    { id: 'F', search: 'Fixo' }
                                                ]"
                                                optionsData="id"
                                                v-model="assinatura.ch_tipo" />
                                        </div>

                                        <!-- Curinga -->
                                        <div :class="assinatura.ch_tipo === 'M' ? 'col-10' : 'col-2'">
                                            <az-input
                                                label="Curinga"
                                                sizing="sm"
                                                placeholder="Curinga"
                                                v-model="assinatura.st_curinga" />
                                        </div>

                                        <!-- Campos para Fixo -->
                                        <template v-if="assinatura.ch_tipo !== 'M'">
                                            <div class="col-2">
                                                <az-input
                                                    label="Nome"
                                                    sizing="sm"
                                                    placeholder="Nome"
                                                    v-model="assinatura.st_nome" />
                                            </div>
                                            <div class="col-2">
                                                <az-input
                                                    label="CPF"
                                                    type="cpf"
                                                    sizing="sm"
                                                    placeholder="CPF"
                                                    v-model="assinatura.st_cpf" />
                                            </div>
                                            <div class="col-2">
                                                <az-input
                                                    label="Nascimento"
                                                    type="date"
                                                    sizing="sm"
                                                    v-model="assinatura.dt_nascimento" />
                                            </div>
                                            <div class="col-2">
                                                <az-input
                                                    label="Email"
                                                    type="email"
                                                    sizing="sm"
                                                    placeholder="Email"
                                                    v-model="assinatura.st_email" />
                                            </div>
                                        </template>

                                        <!-- Botão Remover -->
                                        <div class="col-auto">
                                            <button type="button" class="btn btn-outline-danger btn-sm mb-1"
                                                    @click="remover_assinatura(index)">
                                                <i class="fas fa-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Botão Adicionar Assinatura -->
                            <button type="button" class="btn btn-outline-primary btn-sm" 
                                    @click="adicionar_assinatura()">
                                <i class="fas fa-plus mr-1"></i>
                            </button>
                        </template>                        
                        
                    </div>
                    <div class="modal-footer d-flex justify-content-between">
                        <div>
                            <button class="btn btn-primary mr-1" type="button" v-if="item.id_modelo_documento && !item.fl_layout_word" @click="enviar_arquivo()">
                                <i class="fas fa-plus mr-2"></i>
                                Arquivo
                                <span class="badge badge-light" v-if="item.arquivos && item.arquivos.length">
                                    {{ item.arquivos.length }}
                                </span>
                            </button>
                            <button class="btn btn-primary" type="button"
                                v-if="item.id_modelo_documento && item.procedimento_lista && !item.id_medico"
                                @click="editar_lista_procedimentos(item)">
                                Procedimentos
                                <span class="badge badge-light">{{ item.procedimento_lista.length }}</span>
                            </button>
                        </div>
                        <div>
                            <az-audit-log-button model="modeloDocumento" :id="item.id_modelo_documento" />
                            <button type="button" class="btn btn-secondary mx-2" data-dismiss="modal">Fechar</button>
                            <az-submit @click="atualizar ()">Atualizar</az-submit>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Envio de Arquivo -->
        <template v-if="item && !item.fl_layout_word">
            <az-file-upload
                ref="upload"
                @refresh="refresh_arquivos"
                :tem_validade="true"
                :arquivos="item.arquivos"
                :parms="{ model_type: 'modeloDocumento', model_id: item.id_modelo_documento }" />
        </template>

        <medico-lista ref="medicolista" @refresh="load()" :agenda_compartilhada="true" />
        <procedimento-lista ref="proclista" @refresh="atualizar_lista_procedimento" />

        <!-- Modal Lista Documentos -->
        <div class="modal fade" id="modeloDocumentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="medico_docs">
                    <div class="modal-header">
                        <h5 class="modal-title">Prestador: {{ medico_docs.search }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template>
                            <div class="mb-3">
                                <az-input 
                                    type="button-group" 
                                    :optionsList="[
                                        { id: 'T', search: 'Todos' },
                                        { id: 'S', search: 'Selecionados' },
                                    ]"
                                    v-model="tipo_exibicao" />

                                <az-input
                                    icon="fa fa-search" 
                                    placeholder="Pesquisar..."
                                    v-model="search_docs" />
                            </div>

                            <table class="table table-sm border-0 table-responsive" v-if="false">
                                <tr>
                                    <td class="text-nowrap">
                                        <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in lista_classes" :key="icx">
                                            <span class="badge badge-success mr-1" >
                                                {{ classe }}
                                            </span>
                                        </a>
                                    </td>
                                </tr>
                            </table>

                            <az-empty-state v-if="!lista_documentos_exibicao || !lista_documentos_exibicao.length" msg="Nenhum médico identificado." />

                            <div v-else>

                                <template v-if="tipo_exibicao == 'T'">
                                    <az-input
                                        type="checkbox-group"
                                        label="TODOS"
                                        v-model="todos"
                                        @click="trocando = true;" />

                                    <div v-for="(item, idx) in lista_documentos_exibicao" :key="idx">
                                        <az-input 
                                            type="checkbox-group"
                                            :label="item.st_nome"
                                            v-model="item.selecionado" />
                                    </div>
                                </template>

                                <template v-else>
                                    <template v-for="(item, idx) in lista_documentos_exibicao">
                                        <div class="row" v-show="item.fl_ativo && item.selecionado" :key="idx" v-if="true">
                                            <div class="col col-12">
                                                <label class="form form-control mb-1 text-nowrap text-truncate">
                                                    {{ item.st_nome }}
                                                </label>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </div>

                        </template>
                        
                        <pre v-if="1 == 0" class="alert alert-info">{{ medico_docs }}</pre>
                    </div>
                    <div class="modal-footer">
                        <span class="badge badge-secondary" v-if="lista_documentos">
                            {{ lista_documentos_selecionados }}
                        </span>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="lista_documentos && lista_documentos.length" @click="atualizar_docs_medico()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Seleção do Qockpit -->
        <div class="modal fade" id="qockpitDocsModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Qockpit: Documentos</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-input 
                            icon="fa fa-search" 
                            placeholder="Pesquisar..."
                            v-model="qockpit_search_docs">
                            <template v-slot:buttonposb>
                                <div class="input-group-append" v-if="qockpit_list">
                                    <span class="input-group-text">
                                        {{ lista_qockpit.length }}/{{ qockpit_list.length }}
                                    </span>
                                </div>
                            </template>
                        </az-input>

                        <div class="list-group mt-2" v-if="qockpit_list && item">
                            
                            <button type="button" class="list-group-item list-group-item-action d-flex justify-content-between" 
                                :class="qockpit_doc.id == item.in_qockpit_doc_id ? 'active' : ''" 
                                v-for="(qockpit_doc, iqx) in lista_qockpit" :key="iqx" 
                                @click="selec_qockpit_doc(qockpit_doc)">

                                <div>{{ qockpit_doc.search }}</div>
                                <div><span v-if="qockpit_doc.vigente">v{{ qockpit_doc.vigente.version }}</span></div>

                            </button>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import ConfigMainTitle from '../../../cadastros/shared/ConfigMainTitle.vue';
import AzInput from '../../../shared/forms/AzInput.vue';
import AzEditor from '../../../shared/forms/AzEditor.vue';
import AzSubmit from '../../../util/AzSubmit.vue';
import AzEmptyState from '../../../util/AzEmptyState.vue';
import AzFileUpload from "../../../util/AzFileUpload.vue";
import MedicoLista from '../../../shared/MedicoLista.vue';
import AzSubTitle from '../../../util/AzSubTitle.vue';
import Multiselect from 'vue-multiselect';
import ProcedimentoLista from '../../../shared/ProcedimentoLista.vue';
import AzAuditLogButton from '../../../util/AzAuditLogButton.vue';
import FiltroModel from '../../../cadastros/shared/FiltroModel.vue';
import FiltroRegraCampos from '../../pesquisa/FiltroRegraCampos.vue';

export default {
    data () {
        return {
            dados: null,
            item: null,
            validate: false,
            options_classes: [],
            search: "",
            viewMode: 'A',
            medico: "",
            id_medico: "",
            campos: [],
            novoCampo: "",
            ipsign: false,
            zerodox: false,
            medico_docs: "", 
            lista_documentos: null, 
            search_docs: "", 
            tipo_exibicao: "T",
            trocando: false, 
            ver_vencidos: false,
            qockpit: false, 
            qockpit_list: null, 
            qockpit_search_docs: "", 
        }
    },

    props: ['config'],

    components: {
        ConfigMainTitle,
        AzInput,
        AzSubmit,
        AzEmptyState,
        AzFileUpload,
        MedicoLista,
        AzSubTitle,
        Multiselect,
        ProcedimentoLista,
        AzAuditLogButton,
        FiltroModel,
        AzEditor,
        FiltroRegraCampos, 
    },

    computed: {
        anexos_vencidos: function () { 
            if ( !this.dados || !this.dados.length ) 
                return [];

            let hoje = this.$util.hoje();
            return this.dados.flatMap(item => ( item.arquivos ) ? item.arquivos.filter(item => item.dt_validade && item.dt_validade < hoje) : []);
        }, 

        todos: { 
            get() {
                return this.lista_documentos_exibicao.findIndex(item => !item.selecionado) < 0;
            },
            set(value) {
                if ( this.trocando ) { 
                    this.lista_documentos_exibicao.forEach(element => {
                        element.selecionado = value;
                    });

                    this.trocando = false;
                }
            }
        },

        lista_documentos_exibicao: function () {
            if ( !this.lista_documentos )
                return [];

            let reg = this.$util.getregex(this.search_docs);

            return this.lista_documentos.filter(item => item.fl_ativo)
                    .filter (item => {
                        return ( !this.search_docs || reg.test(JSON.stringify(item)) );
                    });
        },

        lista: function () {
            let reg = this.$util.getregex(this.search);

            let hoje = this.$util.hoje();

            return this.dados && this.dados.length 
                ? this.dados.filter(item => this.viewMode == 'T' || item.fl_ativo)
                    .filter (item => {
                        return ( this.viewMode == 'T' || item.fl_ativo ) &&
                            ( !this.search || reg.test(JSON.stringify(item)) );
                    })
                    .filter(item => !this.ver_vencidos || ( item.arquivos.find(arq => arq.dt_validade && arq.dt_validade < hoje))) 
                : null;
        },

        lista_qockpit: function () {
            let reg = this.$util.getregex(this.qockpit_search_docs);

            return this.qockpit_list && this.qockpit_list.length 
                ? _.orderBy(
                    this.qockpit_list.filter (item => {
                        return ( !this.qockpit_search_docs || item.id == this.item.in_qockpit_doc_id || reg.test(JSON.stringify(item)) );
                    }),
                    doc => doc.id == this.item.in_qockpit_doc_id ? 1 : 2 
                )
                : [];
        },

        lista_opcoes_filtro: function () {
            let opcoes = [
                {id:'App\\azure\\classeProcedimento', search:'Classe do Procedimento', service: 'classe_procedimentos.index'},
                {id:'App\\azure\\especialidade', search:'Especialidade', service: 'especialidades.index'},
                {id:'App\\azure\\amostraMaterial', search:'Material da Amostra', service:'amostra_materiais.index', parms: { filtros: true }},
                {id:'App\\azure\\plano', search:'Operadora/Plano', service: 'planos.index', nosync: true},
                {id:'App\\azure\\operadora', search:'Operadora', service: 'operadoras.index'},
                {id:'App\\azure\\procedimento', search:'Procedimento', service: 'procedimentos.index'},
            ];

            if ( this.$store.state.unidade.unidade_operacaos.length > 1 ) {
                opcoes.push({id:'App\\azure\\unidadeOperacao', search:'Unidade',service:'unidade_operacaos.index'});
            }

            return opcoes;
        },

        lista_documentos_selecionados: function () { 
            if ( !this.lista_documentos ) { 
                return 0;
            }

            return this.lista_documentos.filter(item => item.fl_ativo && item.selecionado).length;
        }

    },

    methods: {
        visualizar_qockpit_doc () { 
            this.$util.load(this, {
                service: 'modelo_documentos',
                func: 'qockpit_doc', 
                parms: { 
                    id: this.item.in_qockpit_doc_id,
                },
                loadTo: res => { 
                    if ( res.openlink ) { 
                    
                        let janela = window.open(res.openlink, '_blank');

                        if ( janela ) { 
                        
                            janela.focus();
                        
                            this.$toast.add({
                                severity: 'success',
                                summary: "Atenção",
                                detail: 'Link: ' + res.openlink,
                                life: 3000
                            });

                        } else { 

                            this.$toast.add({
                                severity: 'success',
                                summary: "Atenção",
                                detail: 'Não foi possível abrir o arquivo. Verifique se há bloqueador de pop-up ativado. Link: ' + res.openlink,
                                life: 3000
                            });

                        }

                    }

                    console.log('doc', res);
                }
            });
        },

        selec_qockpit_doc (doc) { 
            if ( this.item.in_qockpit_doc_id == doc.id ) { 
                this.item.in_qockpit_doc_id = null;     
            } else { 
                this.item.in_qockpit_doc_id = doc.id; 
            }

            $('#qockpitDocsModal').modal('hide');
        },

        get_qockpit_list () { 
            this.qockpit_search_docs = ""; 

            if ( this.qockpit_list === null ) { 
                this.$util.load(this, {
                    service: 'modelo_documentos',
                    func: 'qockpit_list', 
                    loadTo: res => { 
                        this.qockpit_list = res.lista ? res.lista  : [];
                        $('#qockpitDocsModal').modal('show');
                    }
                });
            } else { 
                $('#qockpitDocsModal').modal('show');
            }
        },

        atualizar_docs_medico () { 
            this.$util.atualizar(this, { 
                service: 'medicos',
                func: 'store_model_lista',
                dados: { 
                    lista: this.lista_documentos.filter(item => item.fl_ativo)
                        .map(item => { 
                            return { 
                                id: item.id_modelo_documento, 
                                selecionado: item.selecionado, 
                            }
                        }),
                    model: 'modeloDocumento', 
                    id_medico: this.medico_docs.id_pessoa,
                },
                modal: 'modeloDocumentoModal',
                toast: true, 
                reload: true, 
            });    
        },

        editar_lista_docs () { 
            this.medico_docs = _.cloneDeep(this.medico);

            this.$util.load(this, {
                service: 'modelo_documentos',
                with: [
                    'medico_lista',
                ],
                parms: {
                    selecao: true,
                    cadastro: true,
                    id_medico_selecao: this.medico.id_pessoa, 
                },
                loadTo: res => { 
                    this.lista_documentos = res;
                }
            });

            $('#modeloDocumentoModal').modal('show');
        },

        incluir_medico_bloco () { 
            this.$refs.medicolista.abrir('modeloDocumento', this.lista.map(item => item.id_modelo_documento));
        },

        remover_medico_bloco () { 
            this.$refs.medicolista.abrir('modeloDocumento', this.lista.map(item => item.id_modelo_documento), true);
        },

        incluir_novo_campo() {
            if ( !this.novoCampo )
                return;

            //console.log('novoCampo', this.novoCampo);

            this.item.st_descricao = this.item.st_descricao + ' #' + _.get(this.novoCampo, 'search');

            this.novoCampo = null;

            this.$nextTick(() => {
                this.novoCampo = "";
            });
        },

        editar_lista_procedimentos(modelo) {
            this.$refs.proclista.abrir('modeloDocumento', modelo.id_modelo_documento);
        },

        atualizar_lista_procedimento(dados) {
            this.item.procedimento_lista = dados;
        },

        toggle(item) {
            this.$util.toggle(this, {
                service: 'modelo_documentos',
                dados: item,
            });
        },

        selecionarMedico() {
            this.$store.commit('loading', true);
            this.dados = [];

            this.id_medico = this.medico ? this.medico.id_pessoa : null;

            this.load();
        },

        addTag (newTag) {
            this.options_classes.push(newTag);

            if ( !this.item.js_classes )
                this.item.js_classes = [];

            this.item.js_classes.push(newTag);
        },

        medico_lista (item) {
            this.$refs.medicolista.abrir('modeloDocumento', item.id_modelo_documento);
        },

        remover(item) {
            if ( !confirm("Confirma remover o modelo de documento: '" + item.st_nome + "'?") )
                return;

            this.$util.atualizar(this, {
                service: 'modelo_documentos',
                func: 'destroy',
                dados: {
                    id_modelo_documento: item.id_modelo_documento,
                },
                callback: () => {
                    this.load();
                }
            });
        },

        refresh_arquivos() {
            this.load();
            this.$util.loadItem(this, {
                service: 'modelo_documentos',
                func: 'show',
                id: this.item.id_modelo_documento,
            })
            .then(res => {
                this.item.arquivos = res.arquivos;
            })
            .finally(() => {
                this.$store.commit('loading', false);
            });
        },

        enviar_arquivo_doc() {
            this.$refs.upload_doc.abrir();
        },

        enviar_arquivo(doc = null) {
            if ( doc ) { 

                this.item = _.cloneDeep(doc);

                this.$nextTick(() => { 
                    this.$refs.upload.abrir();        
                });

                return;
            }

            this.$refs.upload.abrir();
        },

        remover_anexo(anexo, idx) {
            this.$util.atualizar(this, {
                service: 'arquivos',
                func: 'destroy',
                dados: {
                    id: anexo.id_arquivo_link,
                },
                reload: true,
                callback: () => {
                    this.item.arquivos.splice(idx, 1);
                }
            })
        },

        incluir () {
            this.validate = false;

            this.editar ({
                id_modelo_documento: null,
                id_medico: this.$store.state.user.id_pessoa,
                st_nome: "",
                st_titulo: "",
                st_descricao: "",
                arquivos: [],
                js_classes: [],
                fl_html: false,
                fl_layout_word: false, 
                id_cabecalho_laudo: "",
                filtros: [],
                fl_solic_proc: false,
                id_procedimento_solic: "",
                id_cid_solic: "",
                assinaturas: [],
                js_regras_pre_atend: [], 
            });
        },

        editar (item) {
            this.validate = false;

            if ( item && !item.js_regras_pre_atend ) {
                item.js_regras_pre_atend = [];
            }

            this.item = { ...item };
            
            // Inicializar array de assinaturas se não existir
            if (!this.item.assinaturas) {
                this.item.assinaturas = [];
            }
            
            $('#editarDocModal').modal('show');
        },

        atualizar () {

            this.$util.atualizar (this, {
                service: 'modelo_documentos',
                dados: this.item,
                modal: 'editarDocModal',
                reload: true,
            });

        },

        // Métodos para gerenciar assinaturas
        adicionar_assinatura() {
            if (!this.item.assinaturas) {
                this.item.assinaturas = [];
            }
            
            this.item.assinaturas.push({
                ch_tipo: 'M', // M - médico, F - fixo
                st_curinga: '',
                st_nome: '',
                st_cpf: '',
                dt_nascimento: '',
                st_email: ''
            });
        },

        remover_assinatura(index) {
            if (confirm('Confirma a remoção desta assinatura?')) {
                // Marcar para remoção ao invés de remover do array
                // Usar $set para garantir reatividade
                this.$set(this.item.assinaturas[index], 'remover', true);
            }
        },

        load () {
            let filtro = this.id_medico ? { id_medico: this.id_medico } : {};

            this.$util.load(this, {
                service: 'modelo_documentos',
                with: [
                    'medico_lista',
                    'procedimento_lista',
                    'filtros.model',
                    'arquivos', 
                    'procedimento_solic',
                    'cid_solic',
                    'assinaturas',
                ],
                parms: {
                    ...filtro,
                    cadastro: true,
                }
            });
        }
    },

    mounted () {
        if ( this.config ) {

            this.breadcrumb = [
                    { name: "Configurações", path: "/cadastros"},
                    { name: "Modelos de Documentos" },
                ];

            this.$store.commit('setBreadcrumb', this.breadcrumb);

        }

        this.$refs['pesquisa'].$refs.input.focus ();

        this.$util.loadItem(this, {
            service: 'modelo_documentos',
            func: 'tags',
        })
        .then(res => {
            this.options_classes = res;
        });

        this.$util.loadItem(this, {
            service: 'etiquetas',
            func: 'campos',
            parms: {
                model: 'atendimento'
            }
        })
        .then(res => {
            this.campos = res;
        });

        this.$util.loadItem(this, {
            service: 'ipsign',
            func: 'ativo',
            configs: ['integracao-zerodox', 'qockpit']
        })
        .then(res => {
            if(res && res.ativo) {
                this.ipsign = res.ativo;
            }
            if ( this.$store.state.contexto['integracao-zerodox'] > 0 ) { 
                this.zerodox = true; 
            }

            if ( this.$store.state.contexto['qockpit'] > 0 ) { 
                this.qockpit = true; 
            }
        });

        this.load ();
    }

}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
